import Provider from "../../../common/providers/new/provider";
import BookmarkFolder from "../models/bookmarkFolder";

export default class BookmarkFolderProvider extends Provider<BookmarkFolder> {

}